import { Link } from "react-router-dom";
import { team } from "../data";

export function Careers() {
  return (
    <section id="careers" className="bg-slate-50 py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_1.3fr] lg:items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-teal-600">
              Careers & Innovation Culture
            </span>
            <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Build the future with brilliant minds
            </h2>
            <p className="mt-5 text-slate-500">
              Our engineers thrive in collaborative, technology-rich
              environments where curiosity drives every breakthrough. Join a
              team redefining what construction machinery can achieve.
            </p>
            <Link
              to="/careers"
              className="mt-8 inline-flex items-center gap-2 rounded-md bg-slate-900 px-6 py-3 text-sm font-bold text-white transition hover:bg-teal-600"
            >
              Explore Open Roles
              <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-6-6 6 6-6 6" />
              </svg>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-5 sm:grid-cols-4">
            {team.map((member) => (
              <div
                key={member.role}
                className="group relative overflow-hidden rounded-2xl shadow-sm ring-1 ring-slate-200/70 transition hover:-translate-y-1 hover:shadow-xl"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    width={1200}
                    height={627}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/10 to-transparent" />
                </div>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <div className="inline-flex items-center gap-1.5 rounded-full bg-teal-500/90 px-3 py-1 text-xs font-semibold text-slate-950 backdrop-blur">
                    {member.role}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
